
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import {toast,Toaster} from "react-hot-toast";

export default function MortalityUpdate() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);

  const [formData, setFormData] = useState({
    userId: "",
    date: "",
    alive: "",
    dead: "",
  });

  /* ✅ FETCH ALL USERS */
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(
          "https://api.livestockify.com/api/admin/users"
        );
        setUsers(res.data);
      } catch (err) {
        console.error("Failed to fetch users", err);
      }
    };

    fetchUsers();
  }, []);

  const selectedUser = users.find(
    (u) => String(u.id) === String(formData.userId)
  );

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  /* ✅ SUBMIT */
  const handleSubmit = async () => {
    try {
      if (!selectedUser) {
        toast.error("Please select a user");
        return;
      }

      if (!formData.date) {
        toast.error("Please select date");
        return;
      }

      const payload = {
        userUuid: selectedUser.uuid,
        mortalityCount: Number(formData.dead),
        cause: "Daily mortality Update",
        remarks: `Alive Birds: ${formData.alive}`,
      };

      await axios.post(
        "https://api.livestockify.com/api/admin/mortality",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      toast.success("Mortality updated successfully ✅");

      // reset form
      setFormData({
        userId: "",
        date: "",
        alive: "",
        dead: "",
      });
    } catch (err) {
      console.error(err.response?.data || err);
      toast.error("Failed to update mortality");
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <Toaster position="top-right" />

      <div className="flex-1 bg-white rounded-l-2xl p-4 sm:p-6">
        <h1 className="text-lg font-semibold text-green-700 mb-6 text-center sm:text-center">
          Mortality Update
        </h1>

        <div className="max-w-3xl mx-auto">
          <div className="space-y-6">
            {/* Select User */}
            <div className="grid grid-cols-1 sm:grid-cols-12 gap-4 items-start">
              <label className="sm:col-span-4 text-sm font-medium text-gray-700 text-center sm:text-right sm:pt-2">
                Select User
              </label>

              <div className="sm:col-span-8">
                <select
                  name="userId"
                  value={formData.userId}
                  onChange={handleChange}
                  className="w-full border rounded-md px-4 py-2 text-sm"
                >
                  <option value="">Select User</option>
                  {users.map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.firstName} {u.lastName} ({u.email})
                    </option>
                  ))}
                </select>

                {selectedUser && (
                  <p className="text-xs text-gray-500 mt-1 text-center sm:text-left">
                    userUuid: {selectedUser.uuid}
                  </p>
                )}
              </div>
            </div>

            {/* Date */}
            <div className="grid grid-cols-1 sm:grid-cols-12 gap-4 items-start">
              <label className="sm:col-span-4 text-sm font-medium text-gray-700 text-center sm:text-right sm:pt-2">
                Date
              </label>

              <div className="sm:col-span-8">
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  className="w-full border rounded-md px-4 py-2 text-sm"
                />
                <p className="text-xs text-gray-500 mt-1">
                  If record exists for same user & date, it will be updated
                </p>
              </div>
            </div>

            {/* Alive Birds */}
            <div className="grid grid-cols-1 sm:grid-cols-12 gap-4 items-center">
              <label className="sm:col-span-4 text-sm font-medium text-gray-700 text-center sm:text-right">
                Number of Alive Birds
              </label>

              <input
                name="alive"
                value={formData.alive}
                onChange={handleChange}
                placeholder="e.g 100"
                className="sm:col-span-8 border rounded-md px-4 py-2 text-sm"
              />
            </div>

            {/* Dead Birds */}
            <div className="grid grid-cols-1 sm:grid-cols-12 gap-4 items-center">
              <label className="sm:col-span-4 text-sm font-medium text-gray-700 text-center sm:text-right">
                Number of Dead Birds
              </label>

              <input
                name="dead"
                value={formData.dead}
                onChange={handleChange}
                placeholder="e.g 5"
                className="sm:col-span-8 border rounded-md px-4 py-2 text-sm"
              />
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-center sm:justify-end gap-4 pt-6">
              <button
                onClick={() => navigate("/all-users")}
                className="px-6 py-2 border rounded-md text-sm"
              >
                Cancel
              </button>

              <button
                onClick={handleSubmit}
                className="px-6 py-2 bg-green-600 text-white rounded-md text-sm"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
